<template>
  <div class="alibabaPuHuiTiFontFamily tripFolder">
    <v-text-field v-model="searchKeyword"
                  @keyup.enter.native="searchInputEnter"
                  id="keywordInputArea_globeOperation" dense outlined placeholder="搜索我的文件"
                  dark hide-details color="#ffffff" style="width:308px;background:#2a2a2a;">
      <template v-slot:append>
        <p style="font-size:16px;font-weight:bold;color:#ffffff;cursor:pointer;" @click="searchInputEnter"
           class="iconfontFamily mt-1">
          &#xe630;</p>
      </template>
    </v-text-field>
    <div style="height: 58px;display: flex;align-items: center;padding-right: 10px;">
      <p v-if="isBatchOperation" style="color: white">{{ batchSelectedItemId.length }}  选中</p>
      <v-spacer></v-spacer>
      <div v-if="isBatchOperation" style="display: flex;align-items: center;color: rgba(166,166,166,1)">
        <p @click="showDeleteMultiFileDialog = true" style="cursor: pointer">删除</p>
        <p @click="cancelBatchDelete" style="margin-left: 12px;cursor: pointer">取消</p>
      </div>
      <div v-if="!isBatchOperation" @click="openPluginSite"
          style="cursor: pointer;display: flex;align-items: center;justify-content: center;border-radius: 8px;background: rgba(0,111,237,1);color: white;width: 107px;height: 32px;">
        <p class="iconfontFamily">&#xe655;</p>
        <p class="ml-2">新建规划</p>
      </div>
      <v-menu v-if="!isBatchOperation" nudge-left="10" nudge-bottom="25">
        <template v-slot:activator="{ on, attrs }">
          <p  v-on="on" v-bind="attrs"  class="iconfontFamily" style="color: rgba(166,166,166,1);margin-left: 17px;cursor: pointer;">&#xe6a3;</p>
        </template>
        <div style="background-color: rgba(56,56,56,1);width: 120px;height: 52px;text-align: center;"
             class="py-2">
          <div @click="beginBatchOperation" class="order-item">
            <div style="color: white;width: 100%;text-align: center;cursor: pointer"
                 class="SiYuanHeiTi">批量操作
            </div>
          </div>
        </div>
      </v-menu>
    </div>
    <div style="width: 100%;height: calc(100% - 58px - 90px);overflow-y: scroll;overflow-x: hidden"
         class="myScrollArea">
      <div @click="clickFolderItem(item)" v-for="(item) in tripFileList" :key="item['fileId']"
           class="folderItem"
           :style="{
             height: isBatchOperation ? '84px' : selectedFileId === item['fileId'] ? '120px' : '84px',
             border: batchSelectedItemId.indexOf(item['fileId']) > -1 || selectedFileId === item['fileId'] ? '1px solid rgba(97,171,255,1)' : '1px solid rgba(128,128,128,1)'
           }">
        <div style="color: white;width: 100%;height: 80px;display: flex;align-items: center;">
          <div style="width: 240px;padding-left: 12px;">
            <p style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis">
              {{ item['fileName'] }}
            </p>
            <div style="display: flex;height: 21px;line-height: 21px;margin-top: 12px;">
              <p class="iconfontFamily"
                 :style="{'color' : item['labelCount'] > 10000 ? 'red' : item['labelCount'] > 2000 ? 'rgba(255,141,26,1)' : 'rgba(0,201,81,1)'}">
                &#xe6b0;</p>
              <p style="margin-left: 12px">对象数量: {{ item['labelCount'] }}</p>
            </div>
          </div>
          <div v-if="!isBatchOperation" @click="viewTripFileDetail(item)" class="viewDetail">
            <p class="iconfontFamily">&#xe6ad;</p>
            <p style="font-size: 14px;">详情查看</p>
          </div>
        </div>
        <div v-if="selectedFileId === item['fileId'] && !isBatchOperation">
          <div style="height: 1px;width: calc(100% - 10px);margin-left: 5px;background: rgba(84,84,84,1)"></div>
          <v-menu nudge-left="-20">
            <template v-slot:activator="{ on, attrs }">
              <div v-on="on" v-bind="attrs" style="font-size: 16px;color:white;margin-left: 275px;margin-top: 8px" class="iconfontFamily">
                &#xec1c;
              </div>
            </template>
            <div style="background-color: rgba(56,56,56,1);width: 120px;height: 52px;text-align: center;"
                 class="py-2">
              <div @click="showDeleteSingleFileDialog = true" class="order-item">
                <div style="color: white;width: 100%;text-align: center;cursor: pointer"
                     class="SiYuanHeiTi">删除
                </div>
              </div>
            </div>
          </v-menu>
        </div>
        <div v-if="isBatchOperation" style="right: 9px;top: 7px;position: absolute">
          <el-checkbox v-model="batchSelectedItemId.indexOf(item['fileId']) > -1"
                       @change="clickFolderItem(item)"></el-checkbox>
        </div>
      </div>
      <div v-if="tripFileList.length === 0" style="color: rgba(166,166,166);display: flex;align-items: center;width: 100%;height: calc(100% - 58px - 90px);justify-content: center">
        <span class="iconfontFamily">&#xe691;</span><span style="margin-left: 13px">文件列表为空</span>
      </div>
      <my-folder-page-number ref="myFolderPageNumber"
                             style="margin-top: 15px;display: flex;align-items: center;height: 35px;width: calc(100% - 4px)"
                             v-if="totalPageNum > 1" :totalPageNum="totalPageNum" :currPageNum="curPageNum"
                             @changePageNumber="changePageNumber"></my-folder-page-number>
    </div>
    <div style="display: flex;align-items: center;color: rgba(166,166,166,1);height: 50px;width: 100%;font-size: 14px;">
      <p class="iconfontFamily">&#xe694;</p>
      <p>数据来自于：吉林一号·星旅</p>
    </div>
    <div v-if="detailCardShow" class="detail-info-card">
      <div style="height: 54px;line-height: 54px;border-bottom: 1px solid rgba(84,84,84,1);display: flex">
        <p class="ml-4 detail-card-title">{{ detailInfo.fileName }}</p>
        <p @click="closeFileDetail" style="cursor:pointer;color: rgba(196,196,196,1);font-size: 12px;margin-left: 18px"
           class="iconfontFamily">
          &#xe659;</p>
      </div>
      <div style="padding: 17px">
        <p style="font-size: 14px;color: rgba(166,166,166,1)">创作者</p>
        <div style="height: 55px;display: flex;align-items: center" v-if="detailInfo.authority === 0">
          <div style="width: 30px;height: 30px;"
               class="avatar-icon"
               :style="{'background-image': 'url(' + detailInfo.avatar + ')'}">
          </div>
          <p style="color: white;margin-left: 10px">{{ detailInfo.nickName }}</p>
        </div>
        <div style="height: 55px;display: flex;align-items: center" v-if="detailInfo.authority === 1">
          <div class="detail-item-key" style="display: flex;align-items: center">
            <div v-for="(item, index) in detailInfo.teamList" :key="index">
              <div class="avatar-icon"
                   :style="{'background-image': 'url(' + item + ')', 'margin-left': index === 0 ? '0' : '-10px'}">
              </div>
            </div>
          </div>
          <p @click="openTeamManage" class="detail-item-value" style="cursor: pointer;color: rgba(97,171,255,1)">
            团队管理</p>
        </div>
        <div>
          <div style="display: flex">
            <p class="detail-item-key">类型</p>
            <p class="detail-item-value">{{ detailInfo.authority === 0 ? '个人文件' : '团队文件' }}</p>
          </div>
          <div style="display: flex">
            <p class="detail-item-key">对象数量</p>
            <p class="detail-item-value">{{ detailInfo.labelCount }}</p>
          </div>
          <div style="display: flex">
            <p class="detail-item-key">更新时间</p>
            <p class="detail-item-value">{{ detailInfo.gmtModifytime }}</p>
          </div>
          <div style="display: flex">
            <p class="detail-item-key">创建时间</p>
            <p class="detail-item-value">{{ detailInfo.gmtCreatetime }}</p>
          </div>
          <div style="margin-top: 10px;display: flex;overflow: hidden">
            <p style="width: 30%;font-size: 14px;color: rgba(166, 166, 166, 1);height: 100%;">使用说明</p>
            <p style="width: 70%;font-size: 16px;color: rgba(255, 255, 255, 1);line-height: 21px;word-break: break-word;height: auto">无</p>
          </div>
          <div style="margin-top: 15px;display: flex;overflow: hidden">
            <p style="width: 30%;font-size: 14px;color: rgba(166, 166, 166, 1);height: 100%;">文件简介</p>
            <p style="width: 70%;font-size: 16px;color: rgba(255, 255, 255, 1);height: 100%;line-height: 21px">无</p>
          </div>
        </div>

      </div>
    </div>
    <delete-file-dialog :dialog-show="showDeleteMultiFileDialog"
                        @closeDeleteFileDialog="showDeleteMultiFileDialog = false"
                        @deleteFileOK="deleteMultiFileOK"></delete-file-dialog>
    <delete-file-dialog :dialog-show="showDeleteSingleFileDialog"
                        @closeDeleteFileDialog="showDeleteSingleFileDialog = false"
                        @deleteFileOK="deleteSingleFileOK"></delete-file-dialog>
  </div>
</template>

<script>
import MyFolderPageNumber from "@/components/page_number/MyFolderPageNumber.vue";
import DeleteFileDialog from "@/views/globe/dialog/file_manage/DeleteFileDialog.vue";

export default {
  name: "MainFolderAITrip",
  components: {DeleteFileDialog, MyFolderPageNumber},
  data() {
    return {
      searchKeyword: '',
      tripFileList: [],
      curPageNum: 1,
      totalItems: 0,
      totalPageNum: 0,
      selectedFileId: '',
      isBatchOperation: false,
      batchSelectedItemId: [],
      showDeleteMultiFileDialog: false,
      showDeleteSingleFileDialog: false,
      pluginUrl: 'https://earth.jl1.cn/plugin/travelPlanHome',
      detailCardFileId: '',
      detailCardShow: false,
      detailInfo: {
        authority: '',
        fileName: '',
        avatar: '',
        nickName: '',
        teamList: [],
        labelCount: '',
        gmtModifytime: '',
        gmtCreatetime: '',
        introduction: '',
      },
    }
  },
  methods: {
    openPluginSite() {
      window.open(this.pluginUrl, '_blank')
    },
    searchInputEnter() {
      this.getTripFileList(this.searchKeyword, 1)
    },
    changePageNumber(num) {
      this.getTripFileList(this.searchKeyword, num)
    },
    clickFolderItem(item) {
      if (this.isBatchOperation) {
        const idx = this.batchSelectedItemId.indexOf(item['fileId'])
        if (idx > -1) {
          this.batchSelectedItemId.splice(idx, 1)
        } else {
          this.batchSelectedItemId.push(item['fileId'])
        }
        return
      }
      this.selectedFileId = item['fileId']
    },
    deleteMultiFileOK() {
      let params = new FormData()
      params.append('fileIdList', this.batchSelectedItemId)
      this.$axios({
        method: 'post',
        url: '/authorApi/z-geo-file/deleteFiles',
        data: params
      }).then((resp) => {
        resp = resp.data
        if (resp.status === 200) {
          this.$store.state.snackbarShow = true
          this.$store.state.snackbarText = "批量删除完成"
          this.$store.state.snackbarType = 'success'
          this.getTripFileList(this.searchKeyword, 1)
          this.isBatchOperation = false
          if (this.batchSelectedItemId.indexOf(this.detailCardFileId) > -1) {
            this.closeFileDetail()
            this.$emit('setOriginalPositionAndClearLayers')
          }
          // 删除了打开的文件
          if (this.batchSelectedItemId.indexOf(this.$store.state.currFolderId) > -1) {
            this.$emit('deleteOpenFile')
          }
          this.showDeleteMultiFileDialog = false
        }
      })
    },
    deleteSingleFileOK() {
      let params = new FormData()
      params.append('fileId', this.selectedFileId)
      this.$axios({
        method: "post",
        url: "/authorApi/z-geo-file/deleteFile",
        data: params
      }).then((resultData) => {
        resultData = resultData.data;
        if (resultData.status === 200) {
          this.$store.state.snackbarShow = true
          this.$store.state.snackbarText = "删除完成"
          this.$store.state.snackbarType = 'success'
          this.getTripFileList(this.searchKeyword, 1)
          if (this.selectedFileId === this.detailCardFileId) {
            this.closeFileDetail()
            this.$emit('setOriginalPositionAndClearLayers')
          }
          if (this.deleteFileId === this.$store.state.currFolderId) {
            this.$emit('deleteOpenFile')
          }
          this.showDeleteSingleFileDialog = false
        }
      })
    },
    closeFileDetail() {
      this.detailCardShow = false
      this.detailCardFileId = ''
    },
    beginBatchOperation() {
      this.selectedFileId = ''
      this.batchSelectedItemId = []
      this.isBatchOperation = true
    },
    cancelBatchDelete() {
      this.batchSelectedItemId = []
      this.isBatchOperation = false
    },
    getTripFileList(keyWord, curPageNum) {
      const maxResultNum = 10
      this.$axios({
        method: 'get',
        url: '/authorApi/z-geo-file/getFileListWithTeam',
        params: {
          keyWord: keyWord,
          curPageNum: curPageNum,
          maxResultNum: maxResultNum,
          fileSourceType: 'trip'
        }
      }).then((resp) => {
        resp = resp.data
        if (resp.status === 200) {
          resp = resp.data
          this.tripFileList = resp['list']
          this.totalItems = resp['totalItems']
          this.totalPageNum = resp['totalPageNum']
          this.curPageNum = curPageNum
        }
      })
    },
    selectFile(item) {
      let idx = this.batchSelectedItemId.indexOf(item['id'])
      if (idx > -1) {
        this.batchSelectedItemId.splice(idx, 1)
      } else {
        this.batchSelectedItemId.push(item['id'])
      }
    },
    getFirstMarker(fileGeo) {
      // bfs获取最浅层的节点geo信息
      let queue = []
      for (let i = 0; i < fileGeo.length; i++) {
        queue.push(fileGeo[i])
      }
      while (queue.length !== 0) {
        let layerCount = queue.length
        for (let i = 0; i < layerCount; i++) {
          let curr = queue.shift()
          if (curr.type !== 'folder') {
            return [curr.geoJson.geo, curr.type]
          } else {
            for (let j = 0; j < curr.children.length; j++) {
              queue.push(curr.children[j])
            }
          }
        }
      }
    },
    async viewTripFileDetail(item) {
      // 跳转到对应的位置 + 展示标记信息
      // 找到第一个文件/文件夹的最近的元素
      let fileGeo = ''
      await this.$axios.get('/authorApi/z-geo-file/openFile', {
        params: {
          'fileId': item['fileId']
        }
      }).then((resultData) => {
        resultData = resultData.data;
        console.log(resultData)
        if (resultData.status === 200) {
          fileGeo = resultData.data.content
        } else {
          console.log(resultData.status + resultData.message);
        }
      })
      this.detailCardShow = true
      this.detailCardFileId = item['fileId']
      this.detailInfo.fileName = item['fileName']
      this.detailInfo.authority = item['authority']
      this.detailInfo.avatar = item['avatar']
      this.detailInfo.nickName = item['nickName']
      this.detailInfo.labelCount = item['labelCount']
      this.detailInfo.gmtModifytime = item['gmtModifytime']
      this.detailInfo.gmtCreatetime = item['gmtCreatetime']
      this.detailInfo.teamList = item['teamList']
      this.detailInfo.introduction = item['introduction']
      this.$emit('showMyFolderEditIcon', item, true)
      if (fileGeo === undefined || fileGeo.length === 0) {
        // 无标记不飞 还是飞向初始位置
        return
      }
      let firstMarkerGeoAndType = this.getFirstMarker(fileGeo)
      this.$emit('flyToFolderFirstMarker', firstMarkerGeoAndType[0], firstMarkerGeoAndType[1])
    },
  },
  mounted() {
    this.getTripFileList(this.searchKeyword,1)
  },
  beforeDestroy() {
    this.$emit('leftBarDestroy', 'myAiTripFolder')
  }
}
</script>

<style scoped>
.tripFolder {
  height: 100%;
  width: 340px;
  padding: 14px 15px 0 15px;
  position: relative;
}

.folderItem {
  width: calc(100% - 4px);
  margin-bottom: 14px;
  border-radius: 8px;
  cursor: pointer;
  position: relative;
}

.folderItem:hover .viewDetail{
  visibility: visible;
}

.viewDetail {
  display: flex;
  flex-direction: column;
  color: white;
  align-items: center;
  visibility: hidden;
}

.order-item {
  display: flex;
  line-height: 36px;
  height: 36px;
  align-items: center;
  cursor: pointer;
}

.order-item:hover {
  background-color: rgba(32, 81, 138, 1);
}


.detail-info-card {
  width: 300px;
  height: auto;
  min-height: 520px;
  border-radius: 2px;
  background-color: rgba(56, 56, 56, 1);
  box-shadow: 4px 4px 10px 1px rgba(0, 0, 0, 0.25);
  position: absolute;
  left: 355px;
  top: 10px;
  z-index: 1;
}

.detail-card-title {
  color: white;
  width: 80%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.detail-item-key {
  width: 30%;
  font-size: 14px;
  color: rgba(166, 166, 166, 1);
  height: 38px;
  line-height: 38px;
}

.detail-item-value {
  width: 70%;
  font-size: 16px;
  color: rgba(255, 255, 255, 1);
  height: 38px;
  line-height: 38px
}
.avatar-icon {
  border-radius: 50%;
  width: 22px;
  height: 22px;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
}
</style>